function startPolling(isPolling, pollInterval, fetchChatMessages) {
  if (isPolling) return { isPolling, pollInterval };
  isPolling = true;
  pollInterval = setInterval(function() { fetchChatMessages(); }, 10000);
  return { isPolling, pollInterval };
}

function stopPolling(pollInterval, isPolling) {
  if (pollInterval) {
    clearInterval(pollInterval);
    pollInterval = null;
  }
  isPolling = false;
  return { isPolling, pollInterval };
}

function fetchPublicChatMessages() {

  // 講師メッセージとAIメッセージの最後の要素のIDを取得
  const tutorMessagesContainer = document.querySelector('.js-p-chat_widget__tutor-messages');
  const aiMessagesContainer = document.querySelector('.js-p-chat_widget__ai-messages');
  let lastMessageId = 0;
  let tutorLastMessageId = 0;
  let aiLastMessageId = 0;

  if (tutorMessagesContainer) {
    const tutorNodes = tutorMessagesContainer.querySelectorAll('[data-message-id]');
    if (tutorNodes.length > 0) {
      const lastNode = tutorNodes[tutorNodes.length - 1];
      tutorLastMessageId = parseInt(lastNode.dataset.messageId || '0', 10) || 0;
    }
  }
  if (aiMessagesContainer) {
    const aiNodes = aiMessagesContainer.querySelectorAll('[data-message-id]');
    if (aiNodes.length > 0) {
      const lastNode = aiNodes[aiNodes.length - 1];
      aiLastMessageId = parseInt(lastNode.dataset.messageId || '0', 10) || 0;
    }
  }
  lastMessageId = Math.max(tutorLastMessageId, aiLastMessageId);

  $.ajax({
    url: '/chat_messages',
    type: 'GET',
    dataType: 'script',
    data: { last_message_id: lastMessageId },
    headers: {
      'X-CSRF-Token': $('meta[name=csrf-token]').attr('content'),
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
}

function initChatAutoRefresh() {
  (function() {
    if (!!$('.js-chat_widget').length) {
      let isPolling = false;
      let pollInterval = null;
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
          const result = stopPolling(pollInterval, isPolling);
          isPolling = result.isPolling;
          pollInterval = result.pollInterval;
        } else {
          const result = startPolling(isPolling, pollInterval, fetchPublicChatMessages);
          isPolling = result.isPolling;
          pollInterval = result.pollInterval;
        }
      });
      setTimeout(() => {
        const result = startPolling(isPolling, pollInterval, fetchPublicChatMessages);
        isPolling = result.isPolling;
        pollInterval = result.pollInterval;
      }, 1000);
    }
  })();
}

window.initChatAutoRefresh = initChatAutoRefresh;